import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"
import { getCalendarReports, resetCalendarReports } from "store/actions"
import TableComponent from "components/Table"
import Flatpickr from "react-flatpickr"
import { SortIcon } from "components/Table_SortColumnIcon"
import { URL_PATHS } from "constants/index"

const CalendarsReport = ({
  history,
  getCalendarReports,
  resetCalendarReports,
  calendarReports,
  match,
}) => {
  const { event_id } = match?.params
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)

  useEffect(() => {
    getCalendarReports({ event_id: event_id })
    return () => {
      resetCalendarReports()
    }
  }, [])

  const searchHanler = () => {
    getCalendarReports({
      event_id: event_id,
      start: startDate,
      end: endDate,
    })
    setShowResetButton(true)
  }

  const resetSearchHandler = () => {
    getCalendarReports({ event_id: event_id })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Calendar Reports" />
          <BreadcrumbTitle
            title={"Calendar Reports"}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Calendar Reports" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>

          <Card>
            <CardBody>
              <Row className="justify-content-center">
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="Start Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={startDate}
                    onChange={(selectedDates, dateStr) => {
                      setStartDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <Flatpickr
                    className="form-control bg-white"
                    placeholder="End Date"
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                    }}
                    value={endDate}
                    onChange={(selectedDates, dateStr) => {
                      setEndDate(dateStr)
                    }}
                  />
                </Col>
                <Col xs="auto" className="my-1">
                  <SaveButton
                    type="button"
                    content="Search"
                    onClick={searchHanler}
                  />
                </Col>
                {showResetButton && (
                  <Col xs="auto" className="my-1">
                    <SaveButton
                      type="button"
                      content="Reset"
                      color="light"
                      onClick={resetSearchHandler}
                    />
                  </Col>
                )}
              </Row>

              <Row className="mt-3">
                <Col>
                  <h5>Event Details Views</h5>
                </Col>
              </Row>
              <TableComponent
                data={calendarReports?.calendar_events_views?.map(
                  (x, index) => ({ id: index, ...x })
                )}
                columns={[
                  {
                    text: "id",
                    dataField: "id",
                    sort: true,
                    hidden: true,
                    formatter: (cellContent, item) => <>{item?.id}</>,
                  },
                  {
                    text: "Calendar Event Name",
                    dataField: "name",
                    sort: true,
                    sortCaret: order => <SortIcon order={order} />,
                    formatter: (cellContent, item) => <>{item?.name}</>,
                  },
                  {
                    text: "# Views",
                    dataField: "total",
                    sort: true,
                    sortCaret: order => <SortIcon order={order} />,
                    formatter: (cellContent, item) => <>{item?.total}</>,
                  },
                ]}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  calendarReports: state.CalendarEvents.calendarReports,
})

const mapDispatchToProps = dispatch => ({
  getCalendarReports: values => dispatch(getCalendarReports(values)),
  resetCalendarReports: () => dispatch(resetCalendarReports()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CalendarsReport))
